import React, { useState } from "react";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";
import { useFormContext } from "react-hook-form";
import { IAcquisitionConfig } from "../Type";
import { editStateAcquisitionConfig } from "../atoms/atoms";
import { useRecoilValue } from "recoil";
import CheckBoxLabelHookForm from "components/CheckBoxLabelHookForm";

const AcquisitionConfigDetails = (props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: IAcquisitionConfig | undefined;
}) => {
  // Props drilled
  const { data, setChanges } = props;

  // Recoil Hook
  const edit = useRecoilValue(editStateAcquisitionConfig);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local Hooks
  const [acquisitionConfigInput, setacquisitionConfigInput] = useState(
    data?.acquisitionName || ""
  );
  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);
  const [isMexicoChange, setIsMexicoChange] = useState(data?.usedInMexico);

  return (
    <>
      <div className="bg-bgDB">
        <div className="m-2 bg-white shadow-lg h-full">
          <div className="grid grid-cols-1 md:grid-cols-3 p-2 place-items-center">
            <div className="px-1 mx-2 w-full">
              <TextInputLabelHookForm
                name="acquisitionName"
                label="Acquisition Name"
                type="text"
                onChange={(e) => {
                  setacquisitionConfigInput(e.target.value);

                  if (
                    e.target.value.trim() === "" ||
                    (e.target.value === data?.acquisitionName &&
                      checkBoxChanges === data?.isActive &&
                      isMexicoChange === data?.usedInMexico)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                  e.target.value = e.target.value.replace(/\s+/g, " ");
                }}
                required={true}
                className={
                  formMethods.formState.errors.acquisitionConfig &&
                  formMethods.formState.errors.acquisitionConfig.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("acquisitionName", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>
            <div className="px-3 mx-2 w-full">
              <CheckBoxLabelHookForm
                name="usedInMexico"
                label={
                  isMexicoChange ? "Uncheck if used in US" : "Check if used in Mexico"
                }
                type="checkbox"
                validation={{
                  required: {
                    value: false,
                    message: "Required Field",
                  },
                }}
                onClick={(e) => {
                  setIsMexicoChange(e.target.checked);

                  if (
                    acquisitionConfigInput?.trim() === "" ||
                    (e.target.checked === data?.usedInMexico &&
                      acquisitionConfigInput === data?.acquisitionName &&
                      checkBoxChanges === data?.isActive)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                }}
                register={register}
              />
            </div>
            {edit && (
              <div className="px-3 mx-2 w-full">
                <CheckBoxLabelHookForm
                  name="isActive"
                  label={
                    checkBoxChanges
                      ? "Uncheck to Deactivate"
                      : "Check to Activate"
                  }
                  type="checkbox"
                  validation={{
                    required: {
                      value: false,
                      message: "Required Field",
                    },
                  }}
                  onClick={(e) => {
                    setCheckBoxChanges(e.target.checked);

                    if (
                      acquisitionConfigInput?.trim() === "" ||
                      (e.target.checked === data?.isActive &&
                        acquisitionConfigInput === data?.acquisitionName &&
                        isMexicoChange === data?.usedInMexico)
                    ) {
                      setChanges(false);
                    } else {
                      setChanges(true);
                    }
                  }}
                  register={register}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AcquisitionConfigDetails;
